import { Component } from '@angular/core';
import { NgbActiveModal, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../services/user.service';
import * as moment from 'moment';
import { ReportService } from '../services/report.service';
import { Router } from '@angular/router';
import { ReportType } from '../models/report-type.model';
import { AdminService } from '../services/admin.service';
import { UpdateService } from './report.service';
import { HttpResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { VacationTypes } from './vacation-Types';
import { VacationTypeCreation } from './vacation-type-creation';
import { TIMEOUTS } from './const-timeout';
import { HTTP_STATUS_CODES } from '../shared.constants/all-constants';
import { ApiConnectService } from '../services/api-connect.service';
import {
  SuccessParams,
  VacationResponse,
  CurrentVacation,
  Vacation,
  ShiftSchedule,
  ShiftResponse,
  GroupUser,
  GroupData,
  ShiftParams,
  VacationParams,
  ReportData
} from './report-datepicker.types';

@Component({
  selector: 'app-report-datepicker',
  templateUrl: './report-datepicker.component.html',
  styleUrls: ['./report-datepicker.component.css']
})
export class ReportDatepickerComponent {
  from: NgbDateStruct;
  to: NgbDateStruct;
  today: Date;
  userId: string;
  reportType: ReportType;
  groupId: GroupData;
  groupName: string;
  wrongIntervalError = false;
  wrongError = false;
  wrongError409 = false;
  wrongError400 = false;
  noScheduleError = false;
  emptyIntervalError = false;
  wrongHeadError = false;
  title;
  rep;
  dateErrorContent = false;
  suc = false;
  successMessage = false;
  isWaiting = false;
  changeLog = '';
  modalLogWindow: boolean;
  actionType: string;
  activeUserId: string;
  currentValue = 1;
  type = VacationTypes.NOT_CHOSEN;
  timeErr: boolean;
  shift = 1;
  currentShift: ShiftSchedule | string | number;
  scheduleId: string;
  group: GroupData;
  scheduleId1: string;
  scheduleId2: string;
  scheduleId3: string;
  shiftCurrent: ShiftSchedule;
  shiftPlanned: ShiftSchedule;
  checkValue = true;
  currenValue = false;
  currentValue2 = true;
  currentValue3 = true;
  currentFrom: string;
  currentTo: string;
  planned: string;
  current = true;
  stateShift: number;
  flagDeleteBtn = false;
  plannedId: string;
  disableFlag = true;
  shiftError: boolean;
  currentVacations: CurrentVacation[] = [];
  isLoaded = true;
  time: number;
  currentFlexbleId: string;
  currentTab = "standard";
  selectedShiftId: string;
  dateCurrent: NgbDateStruct;
  dateStart: NgbDateStruct;
  minDateForExpirence: NgbDateStruct;
  vocationDays: number;
  successKey: VacationTypeCreation;
  successParams: SuccessParams | null = null;
  showConfirmationScreen = false;
  prolongationDays = 0;
  newEndDate: NgbDateStruct;
  VacationTypeEnum = VacationTypes;
  showAllVacations = false;
  allVacations: Vacation[] = [];
  loadingVacations = false;
  private groupReportCompletedRequests = 0;

  constructor(
    public activeModal: NgbActiveModal,
    private reportService: ReportService,
    private userService: UserService,
    private router: Router,
    private updateService: UpdateService,
    private adminService: AdminService,
    private translateService: TranslateService,
    private apiConnectService: ApiConnectService) {
  }

  ngOnInit() {
    const current = new Date();
    this.dateCurrent = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };

    this.dateStart = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: 1
    };

    this.minDateForExpirence = {
      year: 2022,
      month: 1,
      day: 1
    };

    if (this.reportType === 8) {
      this.getShift(this.userId);
    } else {
      this.init();
    }
  }

  toggleVacationsList() {
    this.showAllVacations = !this.showAllVacations;
    if (this.showAllVacations && this.allVacations.length === 0) {
      this.loadAllVacations();
    }
  }

  loadAllVacations() {
    this.loadingVacations = true;
    const userId = this.userId || this.userService.getLocal().id;
    this.userService.getAllVacations(userId).subscribe(
      (response: HttpResponse<Object>) => {
        this.allVacations = response.body as Vacation[];
        console.log('Vacations:', this.allVacations);
        this.loadingVacations = false;
      },
      () => {
        this.loadingVacations = false;
      }
    );
  }

  getVacationStatusClass(status: string): string {
    const statusMap = {
      'approval': 'status-approved',
      'coordination': 'status-pending',
      'canceled': 'status-cancelled',
      'completed': 'status-completed'
    };
    return statusMap[status && status.toLowerCase()] || 'status-default';
  }

  onFromDateChange(date: NgbDateStruct) {
    this.from = date;
    this.syncToDate(date);
  }

  onToDateChange(date: NgbDateStruct) {
    this.to = date;
    this.syncFromDate(date);
  }

  private syncToDate(fromDate: NgbDateStruct) {
    const lastDayOfMonth = new Date(fromDate.year, fromDate.month, 0).getDate();
    if (!this.to || this.to.year !== fromDate.year || this.to.month !== fromDate.month) {
      this.to = { year: fromDate.year, month: fromDate.month, day: lastDayOfMonth };
    }
  }

  private syncFromDate(toDate: NgbDateStruct) {
    if (!this.from || this.from.year !== toDate.year || this.from.month !== toDate.month) {
      this.from = { year: toDate.year, month: toDate.month, day: 1 };
    }
  }

  changed() {
    this.currenValue = this.checkValue;
  }

  setSelect(value: string) {
    this.type = Number(value);
  }

  actionTWO(action: string, id: string) {
    this.actionType = action;
    this.activeUserId = id;
  }

  disabledBtn() {
    return this.changeLog.length >= 3;
  }

  plus() {
    this.currentValue++
  }

  minus() {
    if (this.currentValue > 1) {
      this.currentValue--
    }
  }

  setChangeLog() {
    const fromDate: Date = new Date(this.from.year, this.from.month - 1, this.from.day);
    const fromString: string = moment(fromDate).format('YYYY-MM-DD' + 'T' + moment().format('kk:mm:ss'));
    const group = {
      userID: this.activeUserId,
      description: this.changeLog,
      direction: this.actionType,
      amount: this.currentValue,
      dataCreate: fromString
    };
    this.adminService.changeKarma(group).subscribe(
      () => {
        this.activeModal.close('continue');
      },
      () => {
      });
  }

  setEmployer() {
    const fromDate: Date = new Date(this.from.year, this.from.month - 1, this.from.day);
    const fromString: string = moment(fromDate).format('YYYY-MM-DD' + 'T' + moment().format('kk:mm:ss'));
    this.adminService.changeEmploy(this.userId, fromString).subscribe(
      () => {
        this.activeModal.close(fromDate);
      },
      () => {
      });
  }

  shifyChnage(a: number, id: string) {
    this.shift = a;
    this.scheduleId = id;
    if (this.planned === id) {
      this.checkValue = true;
      this.currenValue = false;
      this.flagDeleteBtn = true;
    } else {
      this.checkValue = false;
      this.currenValue = true;
      this.flagDeleteBtn = false;
    }
  }

  changeTab(data: string) {
    this.currentFlexbleId = null;
    this.currentTab = data;
    this.from = this.dateCurrent;
    data == 'standar' ? this.currentFlexbleId = null : this.currentFlexbleId = this.group.flexibleWorkSchedule[0].id;
  }

  shiftChangeFkexible(id: string) {
    this.currentFlexbleId = id;
  }

  getUserById(id: string) {
    this.userService.getUserFromAPI(id).subscribe(
      (response: HttpResponse<Object>) => {
        this.getList((response.body as any).mainGroup);
      })
  }

  getList(a: string) {
    this.adminService.getGroupByID(a).subscribe(
      (response: HttpResponse<Object>) => {
        localStorage.setItem('Dep', JSON.stringify(response.body));
      },
      () => { },
    );
  }

  getShift(userId: string) {
    this.scheduleId1 = '';
    this.scheduleId = '';
    this.scheduleId2 = '';
    this.scheduleId3 = '';
    this.planned = '';
    this.plannedId = '';
    this.currentShift = '';
    this.flagDeleteBtn = false;
    this.adminService.getUsersShift(userId).subscribe(
      (response: Object) => {
        const body = response as ShiftResponse;
        this.processShiftResponseData(body);
        this.init();
      },
      () => {

      })
  }

  private processShiftResponseData(body: ShiftResponse) {
    if (body.current == null) {
      this.checkValue = false;
      this.currenValue = true;
      this.current = true;
      this.shift = 1;
      this.initializeDefaultShiftSchedule(body);
    } else {
      this.handleCurrentShiftSchedule(body);
    }
    if (body.planned) {
      this.shiftPlanned = body.planned;
      this.planned = body.planned.schedule.id;
      this.plannedId = body.planned.id;
    } else {
      this.planned = '';
    }
  }

  private initializeDefaultShiftSchedule(body: ShiftResponse) {
    if (this.group) {
      if (this.group.workSchedule) {
        this.scheduleId1 = this.group.workSchedule.id;
        this.scheduleId = this.group.workSchedule.id;
        this.flagDeleteBtn = true;
      }
      if (this.group.workScheduleId2) {
        this.scheduleId2 = this.group.workScheduleId2.id;
      }
      if (this.group.workScheduleId3) {
        this.scheduleId3 = this.group.workScheduleId3.id;
      }
    }
    this.shiftCurrent = body.planned;
    if (body.planned) {
      this.planned = body.planned.schedule.id;
      this.plannedId = body.planned.id;
      this.checta();
    } else {
      this.currentShift = 1;
    }
  }

  private handleCurrentShiftSchedule(body: ShiftResponse) {
    this.checkValue = false;
    this.currenValue = true;
    this.current = false;
    this.shiftCurrent = body.current;
    if (this.group) {
      if (this.group.workSchedule) {
        this.scheduleId1 = this.group.workSchedule.id;
        this.scheduleId = this.group.workSchedule.id;
      }
      if (this.group.workScheduleId2) {
        this.scheduleId2 = this.group.workScheduleId2.id;
      }
      if (this.group.workScheduleId3) {
        this.scheduleId3 = this.group.workScheduleId3.id;
      }
    }
    if (body.current.from) {
      this.disableFlag = false;
    }
    this.chect();
    if (this.shiftCurrent.from) {
      this.checkValue = true;
      this.currenValue = false;
    }
  }

  deleteEvent() {
    this.adminService.deleteEvent(this.plannedId).subscribe(
      () => {
        this.getShift(this.userId);
      },
      () => { },
    );
  }

  checta() {
    if (this.shiftCurrent.schedule.id === this.scheduleId1) {
      this.stateShift = 1;
      this.scheduleId = this.shiftCurrent.schedule.id;
    }
    if (this.shiftCurrent.schedule.id === this.scheduleId2) {
      this.stateShift = 2;
      this.scheduleId = this.shiftCurrent.schedule.id;
    }
    if (this.shiftCurrent.schedule.id === this.scheduleId3) {
      this.stateShift = 3;
      this.scheduleId = this.shiftCurrent.schedule.id;
    }
  }

  chect() {
    if (this.shiftCurrent.schedule.id === this.scheduleId1) {
      this.stateShift = 1;
      this.shift = 1;
      this.scheduleId = this.shiftCurrent.schedule.id;
    }
    if (this.shiftCurrent.schedule.id === this.scheduleId2) {
      this.stateShift = 2;
      this.shift = 2;
      this.scheduleId = this.shiftCurrent.schedule.id;
    }
    if (this.shiftCurrent.schedule.id === this.scheduleId3) {
      this.stateShift = 3;
      this.shift = 3;
      this.scheduleId = this.shiftCurrent.schedule.id;
    }
  }

  init() {
    const today: Date = new Date();
    const fromDate = {
      year: 0,
      month: 0
    };
    const toDate = {
      year: 0,
      month: 0
    };

    this.calculateReportDateRanges(today, fromDate, toDate);

    this.today = new Date();
    const lastDay = new Date(toDate.year, toDate.month, 0).getDate();
    const lastDay2 = new Date(toDate.year, toDate.month - 1, 0).getDate();

    this.handleDifferentReportTypesAndDates(fromDate, toDate, lastDay, lastDay2, today);

    this.initializeShiftReport(fromDate, toDate, today, lastDay);
  }

  private initializeShiftReport(fromDate: { year: number; month: number; }, toDate: { year: number; month: number; }, today: Date, lastDay: number) {
    if (this.reportType === 8) {
      this.handleCurrentShiftData(fromDate, toDate, today, lastDay);
      if (this.shiftPlanned) {
        this.handlePlannedShiftData(fromDate, toDate, today, lastDay);
      }
    }
    if (this.from.month == 0 || this.to.month == 0) {
      this.from.month = 12;
      this.from.year = this.from.year - 1;
      this.to.month = 12;
      this.to.year = this.to.year - 1;
    }
    if (this.reportType === 8 && this.currentTab == 'standard') {
      this.from = this.dateCurrent;
    }
  }

  private handlePlannedShiftData(fromDate: { year: number; month: number; }, toDate: { year: number; month: number; }, today: Date, lastDay: number) {
    if (this.shiftPlanned.from && this.shiftPlanned.to) {
      let from = this.shiftPlanned.from.split('-');
      let to = this.shiftPlanned.to.split('-');
      this.currentFrom = this.shiftPlanned.from;
      this.currentTo = this.shiftPlanned.to;
      this.from = { year: Number(from[0]), month: Number(from[1]), day: Number(from[2]) };
      this.to = { year: Number(to[0]), month: Number(to[1]), day: Number(to[2]) };
    } else {
      this.checkValue = false;
      this.currenValue = true;
      this.current = false;
      this.from = { year: fromDate.year, month: toDate.month, day: today.getDate() + 1 };
      this.to = { year: toDate.year, month: toDate.month, day: lastDay };
    }
  }

  private handleCurrentShiftData(fromDate: { year: number; month: number; }, toDate: { year: number; month: number; }, today: Date, lastDay: number) {
    if (this.shiftCurrent) {
      if (this.shiftCurrent.from && this.shiftCurrent.to) {
        let from = this.shiftCurrent.from.split('-');
        let to = this.shiftCurrent.to.split('-');
        this.currentFrom = this.shiftCurrent.from;
        this.currentTo = this.shiftCurrent.to;
        this.from = { year: Number(from[0]), month: Number(from[1]), day: Number(from[2]) };
        this.to = { year: Number(to[0]), month: Number(to[1]), day: Number(to[2]) };
      } else {
        this.checkValue = false;
        this.currenValue = true;
        this.current = false;
        this.from = { year: fromDate.year, month: toDate.month, day: today.getDate() + 1 };
        this.to = { year: toDate.year, month: toDate.month, day: lastDay };
      }
    }
  }

  private handleDifferentReportTypesAndDates(fromDate: { year: number; month: number; }, toDate: { year: number; month: number; }, lastDay: number, lastDay2: number, today: Date) {
    if (this.reportType === 7) {
      this.from = { year: fromDate.year, month: toDate.month - 1, day: 1 };
      this.to = { year: toDate.year, month: toDate.month - 1, day: lastDay };
    }

    if (this.groupName || this.reportType === 1) {
      this.from = { year: fromDate.year, month: toDate.month - 1, day: 1 };
      this.to = { year: toDate.year, month: toDate.month - 1, day: lastDay2 };
    } else {
      if (this.rep === 'norep' || this.reportType === 6 || this.reportType === 9) {
        this.from = { year: fromDate.year, month: toDate.month, day: today.getDate() };
      } else {
        this.from = { year: fromDate.year, month: toDate.month, day: 1 };
      }
      this.to = { year: toDate.year, month: toDate.month, day: lastDay };
    }
  }

  private calculateReportDateRanges(today: Date, fromDate: { year: number; month: number; }, toDate: { year: number; month: number; }) {
    if (today.getMonth() === 0) {
      fromDate.month = 12;
      fromDate.year = today.getFullYear();
      toDate.month = today.getMonth() + 1;
      toDate.year = today.getFullYear();
    } else if (today.getMonth() && today.getMonth() < 11) {
      fromDate.year = today.getFullYear();
      fromDate.month = today.getMonth();
      toDate.month = today.getMonth() + 1;
      toDate.year = today.getFullYear();
    } else if (today.getMonth() === 11) {
      fromDate.year = today.getFullYear();
      fromDate.month = today.getMonth();
      toDate.month = today.getMonth() + 1;
      toDate.year = today.getFullYear();
    }
  }

  checkDay() {
    if (this.from) {
      return new Date(this.from.year + '-' + this.from.month + '-' + this.from.day) > new Date(this.today);
    }
  }

  checDateFf() {
    if (this.from) {
      return (new Date(this.to.year + '-' + this.to.month + '-' + this.to.day)).getTime() >= (new Date(this.from.year + '-' + this.from.month + '-' + this.from.day)).getTime();
    }
  }

  checDateRavn() {
    if (this.from) {
      let isFromEquals = (new Date(this.currentFrom)).getTime() == (new Date(this.from.year + '-' + this.from.month + '-' + this.from.day)).getTime();
      let isToEquals = (new Date(this.currentTo)).getTime() == (new Date(this.to.year + '-' + this.to.month + '-' + this.to.day)).getTime();
      return (this.shift == this.stateShift) && (isFromEquals && isToEquals);
    }
  }

  public cancelConfirmationRequest(): void {
    this.showConfirmationScreen = false;
  }

  isDisabled(): boolean {
    return (
      !this.disabledBtn() ||
      this.type === VacationTypes.NOT_CHOSEN ||
      this.suc ||
      this.isWaiting ||
      this.showConfirmationScreen
    );
  }

  isContinueDisabled(): boolean {
    return (
      this.shift !== 1 &&
      this.checkValue &&
      (!this.checkDay() || !this.checDateFf() || this.checDateRavn())
    );
  }

  submitVacationRequest(): void {
    const fromDate: Date = new Date(
      this.from.year,
      this.from.month - 1,
      this.from.day
    );
    let params = this.prepareVacationRequestParameters(fromDate);

    this.userService.postVocation(params).subscribe(
      (httpResponse: HttpResponse<Object>) => {
        this.processVacationResponseData(httpResponse);
      },
      (error: any) => {
        this.handleVacationRequestError(error);
      }
    );
  }

  private prepareVacationRequestParameters(fromDate: Date) {
    const toDate: Date = new Date(this.to.year, this.to.month - 1, this.to.day);
    const convertFromString: string = moment(fromDate).format("YYYY-MM-DD");
    const convertToString: string = moment(toDate).format("YYYY-MM-DD");

    this.isWaiting = true;
    this.timeErr = false;

    let params = {
      from: convertFromString,
      to: convertToString,
      vacationType: VacationTypes[this.type],
      description: this.changeLog,
    };
    return params;
  }

  private processVacationResponseData(httpResponse: HttpResponse<Object>) {
    const response = httpResponse.body as VacationResponse;
    const startDateParts = response.start.split("-");
    const formattedStartDate = `${startDateParts[2]}.${startDateParts[1]}.${startDateParts[0]}`;
    const finishDateParts = response.finish.split("-");
    const formattedFinishDate = `${finishDateParts[2]}.${finishDateParts[1]}.${finishDateParts[0]}`;

    this.successKey = VacationTypeCreation.vacation_created;
    this.createSuccessParametersForVacationResponse(formattedStartDate, formattedFinishDate, response);
    this.successMessage = true;
    const planfixUrl = this.apiConnectService.getPlanfixTaskUrl(response.idPf);
    window.open(planfixUrl);
    setTimeout(() => this.activeModal.close("ok"), TIMEOUTS.LONG);
  }

  private createSuccessParametersForVacationResponse(formattedStartDate: string, formattedFinishDate: string, response: VacationResponse) {
    this.successParams = {
      start: formattedStartDate,
      finish: formattedFinishDate,
      extension: response.countExtendDays > 0
        ? this.translateService.instant(
          String(VacationTypeCreation.vacation_extention),
          { days: response.countExtendDays }
        )
        : "",
    };
  }

  private handleVacationRequestError(error: any) {
    this.isWaiting = false;
    switch (error.status) {
      case 409:
        this.currentVacations = error.error as CurrentVacation[];
        this.wrongError409 = true;
        break;
      case 400:
        this.wrongError400 = true;
        this.vocationDays = Number((error.error && error.error.message || '').replace("-", "") || 0) + 1;
        break;
      default:
        this.handleErrorResponses(error);
        break;
    }
  }

  handleVacationRequest(fromString: string, toString: string): void {
    if (this.type !== this.VacationTypeEnum.PAID_LEAVE) {
      this.submitVacationRequest();
      return;
    }

    this.isWaiting = true;
    this.wrongError = false;

    this.userService
      .getRequestOnProlong(fromString, toString)
      .finally(() => {
        this.isWaiting = false;
      })
      .subscribe(
        (response: HttpResponse<number>) => {
          const plusDays = response.body as number;

          if (plusDays && plusDays) {
            this.prepareProlongationConfirmation(plusDays);
          } else {
            this.submitVacationRequest();
          }
        },
        () => {
          this.wrongError = true;
        }
      );
  }

  prepareProlongationConfirmation(daysToAdd: number): void {
    this.prolongationDays = daysToAdd;
    const originalToDate = new Date(
      this.to.year,
      this.to.month - 1,
      this.to.day
    );
    originalToDate.setDate(originalToDate.getDate() + daysToAdd);
    this.newEndDate = {
      year: originalToDate.getFullYear(),
      month: originalToDate.getMonth() + 1,
      day: originalToDate.getDate(),
    };

    this.showConfirmationScreen = true;
  }

  sendRequest() {
    this.wrongIntervalError = false;
    this.noScheduleError = false;
    this.emptyIntervalError = false;
    this.reportService.clearRowNames();
    const fromDate: Date = new Date(this.from.year, this.from.month - 1, this.from.day);
    const toDate: Date = new Date(this.to.year, this.to.month - 1, this.to.day);

    if (this.currentTab !== 'flexible') {
      if (toDate < fromDate) {
        this.dateErrorContent = true;
        return;
      }
    }

    const fromString: string = moment(fromDate).format('YYYY-MM-DD');
    const toString: string = moment(toDate).format('YYYY-MM-DD');
    this.reportService.reportsMin = [];
    this.handleReportTypeSwitch(fromString, toString, fromDate);
  }

  private handleReportTypeSwitch(fromString: string, toString: string, fromDate: Date) {
    switch (this.reportType) {
      case ReportType.BY_DAY_OFF: {
        this.userService.getReportByUserIdOff(fromString, toString, this.userId).subscribe(
          () => {
            this.suc = true;
            this.activeModal.close('ok');
          },
          (error: any) => {
            this.handleByDayOffError(error);
          }
        );
        break;
      }
      case ReportType.BY_DAY_OFF_GROUP: {
        const fromString: string = moment(fromDate).format('YYYY-MM-DD');

        this.userService.getReportByGroupIdOff(this.groupId.id, fromString).subscribe(
          () => {
            this.suc = true;
            this.activeModal.close('ok');
          },
          (error: any) => {
            this.handleByDayOffGroupError(error);
          }
        );
        break;
      }
      case ReportType.BY_USER: {
        this.userService.getReportByUserId(fromString, toString, this.userId).subscribe(
          (response: HttpResponse<Object>) => {
            if (response.status === 200) {
              this.processByUserReportResponse(response, fromString, toString);
            }
          },
          (error: any) => {
            this.handleByUserReportError(error);
          }
        );
        break;
      }
      case ReportType.BY_USER_DEP: {
        this.userService.getReportByUserId(fromString, toString, this.userId).subscribe(
          (response: HttpResponse<Object>) => {
            if (response.status === 200) {
              this.processByUserDepartmentReportResponse(response, fromString, toString);
            }
          },
          (error: any) => {
            this.handleErrorResponses(error);
          }
        );
        break;
      }
      case ReportType.BY_GROUP: {
        this.startGroupReportGeneration(fromString, toString);
        break;
      }
      case ReportType.BY_VECTOR: {
        this.adminService.getFullVector((this.groupId as any).id || this.groupId, fromString + 'T00:00:00', toString + 'T23:59:59').subscribe(
          (response: HttpResponse<Object>) => {
            if (response.status === 200) {
              localStorage.setItem('dataList', JSON.stringify(response.body));
              this.activeModal.close('ok');
            }
          },
          (error: any) => {
            this.handleVectorErrorResponse(error);
          }
        );
        break;
      }
      case ReportType.BY_VECTOR_ALL_GROUP: {
        this.adminService.getFullVectorAll(fromString + 'T00:00:00', toString + 'T23:59:59').subscribe(
          (response: HttpResponse<Object>) => {
            if (response.status === 200) {
              localStorage.setItem('dataList', JSON.stringify(response.body));
              this.activeModal.close('ok');
            }
          },
          (error: any) => {
            this.handleVectorAllGroupErrorResponse(error);
          }
        );
        break;
      }
      case ReportType.BY_VACATION: {
        this.handleVacationRequest(fromString, toString);
        break;
      }
      case ReportType.SHIFT: {
        let param: ShiftParams;
        if (!this.currenValue) {
          param = {
            idUser: this.userId,
            scheduleId: this.scheduleId,
            from: fromString + 'T00:00:00',
            to: toString + 'T23:59:59'
          };
        } else {
          param = this.createShiftParametersBasedOnTab(param, fromString);
        }
        this.adminService.pullShift(param).subscribe(
          (response: HttpResponse<Object>) => {
            if (response.status === 200) {
              this.activeModal.close('ok');
            }
          },
          (error: any) => {
            if (error.status == 409) {
              this.shiftError = true;
              setTimeout(() => this.shiftError = false, TIMEOUTS.MEDIUM_LONG);
            }
          }
        );
        break;
      }
      default: {
        this.router.navigate(['/dashboard']);
      }
    }
  }

  private processByUserReportResponse(response: HttpResponse<Object>, fromString: string, toString: string) {
    this.reportService.reportsMin = response.body as ReportData[];
    this.getUserById(this.reportService.reportsMin[0].userID);
    this.reportService.reportsMin.forEach(i => {
      i.summaryRecord.salarySupplements = Number(i.summaryRecord.salarySupplements);
      i.summaryRecord.wageRate = Number(i.summaryRecord.wageRate);
    });
    this.reportService.reportsMin.forEach((item, j) => {
      this.reportService.reportsMin[j].howSalaryCalculated.forEach((item, i) => {
        if (item) {
          if (!item.includes('-') && i > 4) {
            this.reportService.reportsMin[j].howSalaryCalculated[i] = '+ ' + item;
          }
        }
      });
    });
    this.finalizeByUserReport(fromString, toString);
  }

  private finalizeByUserReport(fromString: string, toString: string) {
    this.reportService.allReports = [];
    this.reportService.filteredReports = [];
    this.reportService.reportDate = 'Report from ' + fromString + ' to ' + toString;
    localStorage.setItem('ReportDateFrom', fromString);
    localStorage.setItem('ReportDateTo', toString);
    localStorage.setItem('ReportDate', this.reportService.reportDate);
    localStorage.setItem('Reports', JSON.stringify(this.reportService.reportsMin));
    localStorage.setItem('Drts', '');
    if (this.router.url == '/dashboard/report') {
      this.updateService.notifyUpdate();
    }
    this.activeModal.close();
    this.router.navigate(['/dashboard/report/']);
  }

  private processByUserDepartmentReportResponse(response: HttpResponse<Object>, fromString: string, toString: string) {
    this.reportService.reportsMin = response.body as ReportData[];
    this.getUserById(this.reportService.reportsMin[0].userID);
    this.reportService.reportsMin.forEach(i => {
      i.summaryRecord.salarySupplements = Number(i.summaryRecord.salarySupplements);
      i.summaryRecord.wageRate = Number(i.summaryRecord.wageRate);
    });
    this.reportService.reportsMin.forEach((item, j) => {
      this.reportService.reportsMin[j].howSalaryCalculated.forEach((item, i) => {
        if (item) {
          if (!item.includes('-') && i > 4) {
            this.reportService.reportsMin[j].howSalaryCalculated[i] = '+ ' + item;
          }
        }
      });
    });
    this.finalizeByUserDepartmentReport(fromString, toString);
  }

  private finalizeByUserDepartmentReport(fromString: string, toString: string) {
    this.reportService.allReports = [];
    this.reportService.filteredReports = [];
    this.reportService.reportDate = 'Report from ' + fromString + ' to ' + toString;
    localStorage.setItem('ReportDateFrom', fromString);
    localStorage.setItem('ReportDateTo', toString);
    localStorage.setItem('ReportDate', this.reportService.reportDate);
    localStorage.setItem('Reports', JSON.stringify(this.reportService.reportsMin));
    localStorage.setItem('Drts', '');
    this.activeModal.close();
    this.router.navigate(['/dashboard/report/' + this.userId]);
  }

  private processIndividualUserReportsInGroup(fromString: string, toString: string, userObj: GroupUser, completedRequests: number, totalRequests: number) {
    this.userService.getReportByUserId(fromString, toString, userObj.user.id).subscribe(
      (response: HttpResponse<Object>) => {
        if (response.status === 200) {
          this.processGroupReportResponseData(response);
        } else {
          console.error('Error with status:', response.status);
        }
        this.time--;
        completedRequests++;
        if (completedRequests === totalRequests) {
          this.finalizeGroupReport(fromString, toString);
        }
      },
      () => {
        this.time--;
        completedRequests++;
        if (completedRequests === totalRequests) {
          this.finalizeGroupReportOnError(fromString, toString);
        }
      }
    );
    return completedRequests;
  }

  private processGroupReportResponseData(response: HttpResponse<Object>) {
    (response.body as ReportData[]).forEach(report => {
      report.summaryRecord.salarySupplements = Number(report.summaryRecord.salarySupplements);
      report.summaryRecord.wageRate = Number(report.summaryRecord.wageRate);
      report.howSalaryCalculated.forEach((item, index) => {
        if (item && !item.includes('-') && index > 4) {
          report.howSalaryCalculated[index] = '+ ' + item;
        }
      });
      this.reportService.reportsMin.push(report);
    });
  }

  private finalizeGroupReport(fromString: string, toString: string) {
    this.reportService.allReports = this.reportService.reportsMin.concat(this.reportService.filteredReports);
    this.reportService.reportDate = 'Report from ' + fromString + ' to ' + toString;
    localStorage.setItem('ReportDateFrom', fromString);
    localStorage.setItem('ReportDateTo', toString);
    localStorage.setItem('ReportDate', this.reportService.reportDate);
    localStorage.setItem('Reports', JSON.stringify(this.reportService.reportsMin));
    localStorage.setItem('groupName', this.groupName);
    localStorage.setItem('Drts', 'group');
    this.activeModal.close();
    this.isLoaded = true;
    this.router.navigate(['/dashboard/report/group']);
  }

  private finalizeGroupReportOnError(fromString: string, toString: string) {
    this.reportService.allReports = this.reportService.reportsMin.concat(this.reportService.filteredReports);
    this.reportService.reportDate = 'Report from ' + fromString + ' to ' + toString;
    localStorage.setItem('ReportDateFrom', fromString);
    localStorage.setItem('ReportDateTo', toString);
    localStorage.setItem('ReportDate', this.reportService.reportDate);
    localStorage.setItem('Reports', JSON.stringify(this.reportService.reportsMin));
    localStorage.setItem('groupName', this.groupName);
    localStorage.setItem('Drts', 'group');
    this.activeModal.close();
    this.isLoaded = true;
    this.router.navigate(['/dashboard/report/group']);
  }

  private startGroupReportGeneration(fromString: string, toString: string): void {
    this.isLoaded = false;
    this.groupReportCompletedRequests = 0;

    const users = this.groupId.activeUsers;
    this.time = users.length;

    if (users.length === 0) {
      this.finishGroupReportGeneration(fromString, toString);
      return;
    }

    users.forEach((userObj: GroupUser) => {
      this.processSingleUserReport(userObj, fromString, toString);
    });
  }

  private processSingleUserReport(userObj: GroupUser, from: string, to: string): void {
    this.userService.getReportByUserId(from, to, userObj.user.id).subscribe(
      (response: HttpResponse<Object>) => {
        if (response.status === 200) {
          this.processReportResponseData(response.body as ReportData[]);
        } else {
          console.error('Error with status:', response.status);
        }
        this.checkGroupReportCompletion(from, to);
      },
      (error) => {
        console.error('Request failed', error);
        this.checkGroupReportCompletion(from, to);
      }
    );
  }

  private processReportResponseData(reports: ReportData[]): void {
    if (!reports) return;

    reports.forEach(report => {
      this.formatReportFields(report);
      this.reportService.reportsMin.push(report);
    });
  }

  private formatReportFields(report: ReportData): void {
    const summary = report.summaryRecord;
    summary.salarySupplements = Number(summary.salarySupplements);
    summary.wageRate = Number(summary.wageRate);

    report.howSalaryCalculated.forEach((item, index) => {
      if (item && !item.includes('-') && index > 4) {
        report.howSalaryCalculated[index] = '+ ' + item;
      }
    });
  }

  private checkGroupReportCompletion(from: string, to: string): void {
    this.time--;
    this.groupReportCompletedRequests++;

    const totalRequests = this.groupId.activeUsers.length;

    if (this.groupReportCompletedRequests === totalRequests) {
      this.finishGroupReportGeneration(from, to);
    }
  }

  private finishGroupReportGeneration(from: string, to: string): void {
    this.reportService.allReports = this.reportService.reportsMin.concat(this.reportService.filteredReports);
    this.reportService.reportDate = `Report from ${from} to ${to}`;

    this.saveReportContextToStorage(from, to);

    this.activeModal.close();
    this.isLoaded = true;
    this.router.navigate(['/dashboard/report/group']);
  }

  private saveReportContextToStorage(from: string, to: string): void {
    localStorage.setItem('ReportDateFrom', from);
    localStorage.setItem('ReportDateTo', to);
    localStorage.setItem('ReportDate', this.reportService.reportDate);
    localStorage.setItem('Reports', JSON.stringify(this.reportService.reportsMin));
    localStorage.setItem('groupName', this.groupName);
    localStorage.setItem('Drts', 'group');
  }

  private handleErrorResponses(error: any) {
    switch (error.status) {
      case HTTP_STATUS_CODES.NOT_ACCEPTABLE: // 406
        this.wrongHeadError = true;
        break;
      case HTTP_STATUS_CODES.PRECONDITION_FAILED: // 412
        this.wrongIntervalError = true;
        break;
      case HTTP_STATUS_CODES.FAILED_DEPENDENCY: // 424
        this.noScheduleError = true;
        break;
      case HTTP_STATUS_CODES.PRECONDITION_REQUIRED: // 428
        this.emptyIntervalError = true;
        break;
      case HTTP_STATUS_CODES.CONFLICT: // 409
        this.wrongError409 = true;
        break;
      case HTTP_STATUS_CODES.BAD_REQUEST: // 400
        this.wrongError400 = true;
        break;
      default:
        this.wrongError = true;
        break;
    }
  }

  private handleVectorErrorResponse(error: any) {
    this.handleErrorResponses(error);
  }

  private handleVectorAllGroupErrorResponse(error: any) {
    this.handleErrorResponses(error);
  }

  private handleByDayOffError(error: any) {
    this.handleErrorResponses(error);
  }

  private handleByDayOffGroupError(error: any) {
    this.handleErrorResponses(error);
  }

  private handleByUserReportError(error: any) {
    this.handleErrorResponses(error);
  }

  private createShiftParametersBasedOnTab(param: ShiftParams, fromString: string) {
    if (this.currentTab == 'flexible') {
      param = {
        idUser: this.userId,
        scheduleId: this.currentFlexbleId,
        from: fromString + 'T00:00:00',
      };
    } else {
      param = {
        idUser: this.userId,
        scheduleId: this.scheduleId
      };
    }
    return param;
  }

  action(title: string) {
    this.title = title;
  }

  getPlanfixUrl(taskId: number): string {
    return this.apiConnectService.getPlanfixTaskUrl(taskId);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/modals/report-datepicker.component.ts